// Copyright (c) 2016 Deere & Company

import OtherCreditsPanelContainer from './other-credits-panel-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    errors: state.claims.track.claim.errors,
    isEditable: state.claims.track.isEditable,
    otherCreditDescriptions: state.claims.otherCreditDescriptions,
    otherCredits: state.claims.track.claim.otherCredits
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(OtherCreditsPanelContainer);



// WEBPACK FOOTER //
// ./src/claim/track/components/other-credits-panel/index.js